// THIS FILE IS AUTOGENERATED. DO NOT EDIT
/* eslint-disable */
/* tslint:disable */
export * from './TabContent'
export * from './TabItem'
export * from './TabItem2'
export * from './Tabs'
export * from './Tabs2'